import { registerTag } from "./register-tag.js";

import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import DashboardIngredientList from "./dashboard-ingredient-list.vue";
import IngredientTypeFilter from "./ingredient-type-filter.vue";
import IngredientMetaListSearch from "./ingredient-meta-list-search.vue";
import IngredientMetaListEdit from "./ingredient-meta-list-edit.vue";
import RecipeSelectorDashboard from "./recipe-selector-dashboard.vue";
import PrintDialog from "./print-dialog.vue";
import RecipeTagInput from "./recipe-tag-input.vue";
import IngredientTagInput from "./ingredient-tag-input.vue";
import TagInput from "./tag-input.vue";
import TagLabel from "./tag-label.vue";
import BulkActions from "./bulk-manage-recipes/bulk-actions.vue";
import ServingSizeCalculatorModal from "./serving-size-calculator-modal.vue";
import ServingSizeCalculatorPublic from "./serving-size-calculator-public.vue";
import RecipeCostCalculator from "./recipe-cost-calculator.vue";

import ShowRecipesForIngredient from "./show-recipes-for-ingredient/show-recipes-for-ingredient.vue";
import IngredientRecipesList from "./ingredient-recipes-list.vue";

import ManageInventoryMembers from "./user-edit/manage-inventory-members.vue";
import SupplementEditor from "./supplement-editor/supplement-editor.vue";
import SupplementDashboard from "./supplement-dashboard.vue";
import AttachmentsPanel from "./attachments-panel.vue";
import OrderItemsTable from "./order-items-table.vue";
import OrderReceiveTable from "./order-receive-table.vue";
import PurchaseOrderList from "./purchase-order-list.vue";
import ProductionPlanOrders from "./production-plan-orders.vue";
import ShipmentItemsTable from "./shipment-items-table.vue";
import ShipmentList from "./shipment-list.vue";
import ProductionRunLotCodes from "./production-run-lot-codes.vue";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const usePinia = (app) => app.use(pinia);

const options = { beforeMount: usePinia };

// main components
registerTag("dashboard-ingredient-list", { component: DashboardIngredientList, ...options });
registerTag("ingredient-meta-list-search", { component: IngredientMetaListSearch, ...options });
registerTag("ingredient-meta-list-edit", { component: IngredientMetaListEdit, ...options });
registerTag("recipe-selector-dashboard", { component: RecipeSelectorDashboard, ...options });
registerTag("print-dialog", { component: PrintDialog, ...options });
registerTag("recipe-tag-input", { component: RecipeTagInput, ...options });
registerTag("ingredient-tag-input", { component: IngredientTagInput, ...options });
registerTag("tag-input", { component: TagInput, ...options });
registerTag("tag-label", { component: TagLabel, ...options });
registerTag("ingredient-type-filter", { component: IngredientTypeFilter, ...options });
registerTag("bulk-actions", { component: BulkActions, ...options });
registerTag("serving-size-calculator-modal", { component: ServingSizeCalculatorModal, ...options });
registerTag("serving-size-calculator-public", {
  component: ServingSizeCalculatorPublic,
  ...options,
});
registerTag("recipe-cost-calculator", { component: RecipeCostCalculator, ...options });

// show-recipes-for-ingredient
registerTag("show-recipes-for-ingredient", { component: ShowRecipesForIngredient, ...options });
registerTag("ingredient-recipes-list", { component: IngredientRecipesList, ...options });

// user-edit
registerTag("manage-inventory-members", { component: ManageInventoryMembers, ...options });

// supplement-labels
registerTag("supplement-editor", { component: SupplementEditor, ...options });
registerTag("supplement-dashboard", { component: SupplementDashboard, ...options });

// attachments
registerTag("attachments-panel", { component: AttachmentsPanel, ...options });

// orders
registerTag("order-items-table", { component: OrderItemsTable, ...options });
registerTag("order-receive-table", { component: OrderReceiveTable, ...options });
registerTag("purchase-order-list", { component: PurchaseOrderList, ...options });
registerTag("production-plan-orders", { component: ProductionPlanOrders, ...options });

// shipments
registerTag("shipment-items-table", { component: ShipmentItemsTable, ...options });
registerTag("shipment-list", { component: ShipmentList, ...options });

// production-runs
registerTag("production-run-lot-codes", { component: ProductionRunLotCodes, ...options });
